import {BaseApi} from '@/core/api/base.api'
import {Room} from "@/core/api/room.api";
import {roomGoalScheduleService} from '@/core/service/room.goalSchedule.service'
import _ from 'lodash'

class RoomGoalScheduleApi extends BaseApi {
  #roomScheduleData
  constructor() {
    super()
    Room.GoalSchedule = this

    Room.ready(async e => {
      this._eventListen(this.#Events)

      if(!Room.isLms()){
        return;
      }

      const goalAndScheduleData = (await roomGoalScheduleService.goalAndScheduleList()).data
      const roomGoalList = goalAndScheduleData.goalList
      const roomScheduleList = _.sortBy(goalAndScheduleData.lectureScheduleList, 'seq')

      this.#roomScheduleData = roomScheduleList

      Room.addRoomData({
        roomGoalList,
        roomScheduleList : this.#roomScheduleData
      })
    });
  }

  #Events = {
    room_schedule_state_change(data) {
      let scheduleId = data.data.scheduleId
      let scheduleState = data.data.scheduleState

      this.#roomScheduleData.forEach(rs => {
        if(rs.scheduleState) {
          rs.scheduleState = false
        }

        if(rs.scheduleId == scheduleId) {
          rs.scheduleState = scheduleState
        }
      })
      Room.emit('room_schedule_state_change', this.#roomScheduleData)
    }
  }

  async changeScheduleState(data) {
    await roomGoalScheduleService.changeScheduleState(data)
  }

  async getLectureScheduleCallLayoutInfo(params) {
    return (await roomGoalScheduleService.getLectureScheduleCallLayoutInfo(params)).data;
  }
}

export const RoomGoalSchedule = new RoomGoalScheduleApi();